import React from 'react';

import './najavelist.styles.css';
import OldCard from  '../kartice/oldcard.components';


const NajaveList = props => {      
   if(props.items.length === 0){
       return (
           <div className="center-loader">
               <h2>Nema pronadjenih Izvestaja</h2>
           </div>
       )
   }
   return <ul className="row-izvestajs"> 
       {props.items.map(najava => ( 
           <OldCard 
           key={najava.id}
           id={najava.id}
           naslov={ najava.naslov }
           plan={najava.plan}
           datum={najava.datum} 
           visina={najava.visina}
           duzina={najava.duzina}
           tezina={najava.tezina}
           cena={najava.cena}
           kategorija={najava.kategorija}
           image={`${process.env.REACT_APP_ASSET_URL}/${najava.image}`} 
       />
       ))}

   </ul>


};


export default NajaveList;